import React from 'react'
import styled from 'styled-components/macro';
import { Icon } from 'components/atoms'
import { MediaUploadGallery } from 'containers'
import PropTypes from 'prop-types'
import { useToggle } from 'hooks'

export const RichTextEditorOptionImage = ({
  onChange
}) => {
  const [isOpen, toggle] = useToggle(false)
  const handleSubmit = ({ alt, url }) => {
    onChange(url, 'auto', 'auto', alt);
    toggle()
  }

  return (
    <>
      <MediaUploadGallery isOpen={isOpen} toggle={toggle} onSubmit={handleSubmit} />
      <Option onClick={toggle}>
        <Icon icon="fal fa-image" height={16} />
      </Option>
    </>
  )
}

const Option = styled.div`
    padding: ${props => props.theme.spacing.xs2};
    border-radius: 2px;
    margin: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    background: ${props => props.theme.colors.bgLighterS};
    text-transform: capitalize;
    &:hover {
      background-color: #eee;
    }
`

RichTextEditorOptionImage.propTypes = {
  onChange: PropTypes.func.isRequired,
}

RichTextEditorOptionImage.defaultProps = {
}


export default RichTextEditorOptionImage
